import { render, staticRenderFns } from "./TemplateDetails.vue?vue&type=template&id=04dce4b7&scoped=true&"
import script from "./TemplateDetails.vue?vue&type=script&lang=js&"
export * from "./TemplateDetails.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDetails.vue?vue&type=style&index=0&id=04dce4b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dce4b7",
  null
  
)

export default component.exports